import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { styled } from '@mui/system'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import AdminVendors from './AdminVendors';
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
export default class  AddVendors extends Component {
   constructor(props) {
      super(props)
      this.state = {redirect:false,pagename:'',
open:false,name:'',vname:'',cname:'',ve_id:0,ve_id:'',iscreditlimit:false,ve_creditlimit:'0.00',iscreditterms:false,isvendors:false,creditlimitdisable:true,cu_noofdays:'0',refno:'',
      errormessage:'',erropen:false,btndisabled:false,tab:"0", value:0,countrydata:[],ledgerdata:[],countrylabel:'Select Country',masterlabel:'Select',statelabel:'select state',taxlabel:'vtax Rate',vname:'',
	  ve_emailid:'',vmobileno:'', vphone:'', coid:'', vbilladdress1:'',vbilladdress2:'',vbillcity:'', vbillstate:'',vbillpin:'',
	credit:'',trems:'',vtax:'0',cmonth:'', days:'', policy:'',ve_bankaccountname:'',ve_bankroutingno:'',ve_bankaccountno:'',price:'',ve_credittermsimmediate:'',taxcode:'',ve_creditnoofdays:'0',
	  ve_notes:'', vledger:'',submitbtn:"Save",masterdata:[],statedata:[],taxdata:[],isChecked: false, txtvalue:0,allchecked:false,isallchecked:false, Checkboxvalue:0,credittermstype:'',
	  }
  }
  Vendorsgetdata() {
  if(this.props.id!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=getall&ve_id='+this.props.id)
  .then(resp => {  
  console.log("1099 Vendor Value:", resp.data[0].ve_1099vendor);
    if(resp.data.length>0){
    this.setState({ 
      ve_id:resp.data[0].ve_id,
	  vname:resp.data[0].ve_businessname,
	  cname:resp.data[0].ve_contactname,
	  refno:resp.data[0].ve_referenceno,
	  ve_emailid:resp.data[0].ve_emailid,
	  vmobileno:resp.data[0].ve_mobileno,
	  vphone:resp.data[0].ve_phoneno,
	  coid:resp.data[0].ve_country_id,
	  vbilladdress1:resp.data[0].ve_billingaddress1,
	  vbilladdress2:resp.data[0].ve_billingaddress2,
	  vbillcity:resp.data[0].ve_billingcity,
	  vbillstate:resp.data[0].ve_billingstate,
	  vbillpin:resp.data[0].ve_billingpincode,
	  isvendors: parseInt(resp.data[0].ve_1099vendor) === 1,
	  vtax:resp.data[0].ve_tax_id,
	  vledger:resp.data[0].ve_ledger_id,
	  taxcode:resp.data[0].ve_1099taxcode,
	  ve_creditlimit:resp.data[0].ve_creditlimit,
	  iscreditterms:resp.data[0].ve_setcreditterms,
	   ve_creditnoofdays:resp.data[0].ve_creditnoofdays,
	  credittermstype:resp.data[0].ve_creditnextmonth,
	  ve_credittermsimmediate:resp.data[0].ve_credittermsimmediate,
	  ve_bankaccountname:resp.data[0].ve_bankaccountname,
	  ve_bankroutingno:resp.data[0].ve_bankroutingno,
	  ve_bankaccountno:resp.data[0].ve_bankaccountno,
	  ve_notes:resp.data[0].ve_notes,
    });
  }
});
  }else{
	 this.setState({  
	 ve_id:0,
	  vname:'',
	  cname:'',
	  refno:'',
	 ve_emailid:'',
	 vmobileno:'',
	 vphone:'',
	 coid:'',
	 vbilladdress1:'',
	 vbilladdress2:'',
	 vbillcity:'',
	 vbillstate:'',
	 vbillpin:'',
	 isvendors:false,
	 vtax:'0',
	 vledger:'',
	 taxcode:'',
	 ve_creditlimit:'0.00',
	  iscreditterms:'',
	   ve_creditnoofdays:'0',
	  credittermstype:'',
	  ve_credittermsimmediate:'',
	  ve_bankaccountname:'',
	  ve_bankroutingno:'',
	  ve_bankaccountno:'',
	  ve_notes:'',
	  }); 
 }
    } 
 handlecreditterms = (event) => 
{
	this.setState({iscreditterms: !this.state.iscreditterms});
};
 handlevendors = (event) => 
{
this.setState({isvendors: !this.state.isvendors});
}
	handlecreditlimitChange = (event) => 
{
	this.setState({iscreditlimit: !this.state.iscreditlimit,creditlimitdisable:!this.state.creditlimitdisable},()=>{});
}; 
 onclickvendorclose = (e) => {
	 this.setState({open:!this.state.open});
}
handlevendorClickOpen = (e) => {
  if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {			
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
  this.setState({open:!this.state.open,name:'',ve_emailid:'',vphone:'',vname:'',
	 refno:'',vmobileno:'',coid:'', vbilladdress1:'',vbillcity:'',vbillstate:'',vbillpin:'',vtax:'0',
	taxcode:'',vendors:'',credit:'',trems:'',taxhide:false,ve_creditermsimmediate:'',ve_bankaccountname:'',ve_bankroutingno:'',ve_bankaccountno:'',ve_notes:'',cname:'',
     errormessage:'',erropen:false,tab:"0",newValue:'',vledger:'',Checkboxvalue:0,
  Checkboxvalue:0,isCheck:0,terms:false,ve_id:'',ve_id:0,
	  });
this.countrybind();
this.Vendorsgetdata();
};
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=5')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
 countrybind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
      .then((resp) => {     
	  let CountryApi = resp.data.map(row => {
          return {value:row.co_id, display:row.co_name}
        });
		 this.setState({
          countrydata: [{value:'', display:'Select Country'}].concat(CountryApi)
        },()=>{this.statebind();});
      }).then(data => {
      })
}
statebind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxlocation.php?action=getall')
      .then((resp) => {     
	  let StateApi = resp.data.map(row => {
          return {value:row.lo_state, display:row.lo_state}
        });
		 this.setState({
          statedata: [{value:'', display:'Select State'}].concat(StateApi)
        },()=>{this.taxbind();});
      }).then(data => {
      })
}
 taxbind(){
 axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_mainid=0')
      .then((resp) => {   
	  let TaxApi = resp.data.map(row => {
          return {value: row.tx_id, display:row.taxs}
        });
		 this.setState({
			  taxdata: [{value:'', display:'Select tax'}].concat(TaxApi) 
        });
		this.ledgerbind();
      }).then(data => {       
      })
}
  ledgerbind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_isexpenses=1&sorting=le_id')
	 .then((resp) => {     
	  let LedgerApi = resp.data.map(row => {
          return {value:row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: [{value:'', display:'Select'}].concat(LedgerApi)
        });
      }).then(data => {
      })
}
handleradiocredit = (event) => 
{
	this.setState({credittermstype: event.target.value});
};
 handlecheck=(e)=>{
	this.setState({vendors: !this.state.vendors}); 
 }
  handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
	 this.setState({                   
     Checkbox: event.target.value      
   })
  }
 formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");
    // Format based on length
    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)})-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  };
 myChangeHandler = (event) => {
  const re = /^[0-9\.]+$/;
  let nam = event.target.name;
  let val = event.target.value;
if(nam==="vphone")
{
	const inputValue = event.target.value;
    const formatted = this.formatPhoneNumber(inputValue);
	this.setState({[nam]: formatted}); 
}
else if(nam==="vmobileno" || nam==="ve_creditlimit" || nam==="ve_creditnoofdays")
{
if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }	
}else if(nam==="ve_id" || nam==="vbilladdress1" || nam==="vbilladdress2" || nam==="vbillcity" || nam==="vbillstate" || nam==="vbillpin")
{
 this.setState({[nam]: val},()=>{});
}	else{
  this.setState({[nam]: val},()=>{});
  }
}
   handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
	 this.setState({                   
     Checkbox: event.target.value      
   })
  }
handlevendorclose = (e) => {
	let vname = this.state.vname;
    let cname = this.state.cname;
    let refno = this.state.refno;
	let ve_emailid = this.state.ve_emailid;
	let vmobileno= this .state.vmobileno;
    let vphone = this.state.vphone;
    let coid = this.state.coid;
    let vbilladdress1=this.state.vbilladdress1;
	let vbilladdress2 = this.state.vbilladdress2;
	let vbillcity = this.state.vbillcity;
	let vbillstate= this.state.vbillstate;
	let vbillpin= this.state.vbillpin;
    let isvendors=this.state.isvendors;
	let vtax= this.state.vtax;
	let vledger= this.state.vledger;
	let taxcode= this.state.taxcode;
	let ve_creditlimit= this.state.ve_creditlimit;
	let iscreditterms=this.state.iscreditterms;
	let ve_creditnoofdays= this.state.ve_creditnoofdays;
	let credittermstype= this.state.credittermstype;
	let ve_credittermsimmediate= this.state.ve_credittermsimmediate;
	let ve_bankaccountname= this.state.ve_bankaccountname;
	let ve_bankroutingno= this.state.ve_bankroutingno;
	let ve_bankaccountno= this.state.ve_bankaccountno;
	let  ve_notes= this.state.ve_notes;
	let striscreditterms="0",strcredittermstype="0";
	let strisvendors="0",strvendorstype="0",strimmediate="0";
	if(iscreditterms===true)
	{
		striscreditterms="1";
	}
	else{striscreditterms="0";}
	if(isvendors===true)
	{
		strisvendors="1";
	}
	else{strisvendors="0";}
	if(credittermstype==="1")
	{
		strvendorstype="1";
	}
if(credittermstype==="2")
	{
		strcredittermstype="1";
	}
	if(credittermstype==="3")
	{
		strimmediate="1";
	}
	if(credittermstype!=="1")
	{
		ve_creditnoofdays="0";
	}else{
		ve_creditnoofdays=this.state.ve_creditnoofdays;
	}
 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
 if(vname==="")
{
	this.setState({errormessage:"Please Enter Business Name",erropen:true});
		 return false;
}
if(cname==="")
{
	this.setState({errormessage:"Please Enter Contact Name",erropen:true});
		 return false;
}
if(refno==="")
{
	this.setState({errormessage:"Please Enter Reference  No",erropen:true});
		 return false;
}
if(ve_emailid==="")
{
	this.setState({errormessage:"Please Enter Email.",erropen:true});
	return false;
}
else{
	 if (!remail.test(ve_emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});		
	return false; 
  }
}
if (vmobileno === "") {
  this.setState({ errormessage: "Please Enter Mobile Number", erropen: true });
  return false;
}
if (vphone === "") {
  this.setState({ errormessage: "Please Enter Telephone Number", erropen: true });
  return false;
}
if(coid==="" || coid==="0")
{
	this.setState({errormessage:"Please Select Country",erropen:true});
		 return false;
}
 if(vbillstate==="" || vbillstate==="0")
{
	this.setState({errormessage:"Please  Select State",erropen:true});
		 return false;
}
if(vledger==="" || vledger==="0")
{
	this.setState({errormessage:"Please Select Account Default",erropen:true});
		 return false;
}
if(vtax==="0" || vtax===""  )
{
	this.setState({errormessage:"Please Select Tax",erropen:true});
		 return false;
}
 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  if(this.state.ve_id!=="")
	 {
	  formData.append('ve_id',this.state.ve_id)
	 }else
	 {
		formData.append('ve_id',0)  
	 }
        formData.append('action','insertorupdate') 
		formData.append('ve_businessname',vname)
		formData.append('ve_contactname',cname)
		formData.append('ve_referenceno',refno)
		formData.append('ve_emailid',ve_emailid)
		formData.append('ve_mobileno',vmobileno)
		formData.append('ve_phoneno',vphone)
		formData.append('ve_country_id',coid) 
		formData.append('ve_billingaddress1',vbilladdress1)
		formData.append('ve_billingaddress2',vbilladdress2)
		formData.append('ve_billingcity',vbillcity)
		formData.append('ve_billingstate',vbillstate)
		formData.append('ve_billingpincode',vbillpin)
		formData.append('ve_1099vendor',strisvendors)
		formData.append('ve_tax_id',vtax)
	    formData.append('ve_ledger_id',vledger)
		formData.append('ve_1099taxcode',taxcode)
		formData.append('ve_creditlimit',ve_creditlimit)
		formData.append('ve_setcreditterms',striscreditterms)
		formData.append('ve_creditnoofdays',ve_creditnoofdays)
		formData.append('ve_creditnextmonth',strcredittermstype) 
		formData.append('ve_credittermsimmediate',strimmediate)
		formData.append('ve_bankaccountname',ve_bankaccountname)
		formData.append('ve_bankroutingno',ve_bankroutingno)
		formData.append('ve_bankaccountno',ve_bankaccountno)
		formData.append('ve_cmp_id',localStorage.getItem("ISIcmpid"))
		formData.append('ve_notes',ve_notes)
		formData.append('userid',localStorage.getItem("ISIuserid"))
		axios.post(localStorage.getItem("ISIurl")+"ajaxvendors.php", formData, {
        }).then(res => {
	if(res.data === -1)
{ 
		this.setState({errormessage:"Vendor Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;
	}else{
	 this.props.updatevendor(res.data);
	}   
        });
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};
  	 handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  } 
  	 setIsChecked = (isChecked) => {
    this.setState({isChecked });
	this.setState({Checkbox:0});
  }
  render (){
	    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }
 const { ...props } = this.props;
return(
<React.Fragment>
    <Dialog open={this.state.open} onClose={this.onclickvendorclose} maxWidth="md" fullWidth="true"  className="popup" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Create a new Vendors</DialogTitle>
      <DialogContent >
<div className="formlist">
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	<div className="customerform">
<ul>
	<li>	
	<p className="popformtext">  Business Name <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="vname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vname}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>			
		<li>	
	<p className="popformtext">  Contact Name <span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="cname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.cname}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Reference<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="refno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.refno}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:12}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Email<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="ve_emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ve_emailid}
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>	
	<p className="popformtext"> Mobile<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="vmobileno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vmobileno}
			  inputProps={{tabIndex: "5",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		  <div className="clear"></div>
</li>					  
		<li>
	<p className="popformtext">Telephone<span className="validation">*</span></p>
	<p className="popforminputs"><TextField name="vphone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vphone}
			  inputProps={{tabIndex: "6",maxLength:15}}
			  ref={this.usernameInput}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>
		  </ul>	
			</div>	
<Box sx={{ width: '100%', typography: 'body1' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs
      initialSelectedIndex={0}
      value={this.state.tab || "0"}
      onChange={this.handleChange}
      aria-label="lab API tabs example"
    >
      <Tab label="Account Details" value="0" />
      <Tab label="Payment Details" value="1" />
      <Tab label="Notes" value="2" />
    </Tabs>
  </Box>
    </Box>
		 {this.state.tab==="0" && (
<div className="Accountform">
<div className="addresleft">
<ul>
 <li>
		 <p className="popformtext"> </p>
		  <p  className="popforminputs"><FormControl  className="stadrp">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.coid}}
          onChange={this.myChangeHandler}
          id="coid"
		   value={this.state.coid} className="txtbox"
		  name="coid"
		inputProps={{tabIndex: "7"}}
        >
		{this.state.countrydata.map(con => (
            <option  
              value={con.value}
            >
              {con.display}
            </option  >
          ))}
        </Select></FormControl>
		</p>
		<div className="clear"></div>
		  </li>
		<li>	
	<p className="popformtext">  Address 1</p>
	<p className="popforminputs"><TextField name="vbilladdress1" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vbilladdress1}
		 inputProps={{tabIndex: "8"}}	 
			  ref={this.usernameInput}
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
<li>	
	<p className="popformtext">Address 2 </p>
	<p className="popforminputs"><TextField name="vbilladdress2" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vbilladdress2}
			 inputProps={{tabIndex: "9"}}	 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>	
	<p className="popformtext">Town/City </p>
	<p className="popforminputs"><TextField name="vbillcity" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vbillcity}
			  inputProps={{tabIndex: "10",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>
		 <p className="popformtext"> State </p>
		  <p><FormControl  className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.statelabel, value: this.state.vbillstate}}
          onChange={this.myChangeHandler}
          id="vbillstate"
		   value={this.state.vbillstate}
		   className="txtbox"
inputProps={{tabIndex: "11",maxLength:150}}	
		  name="vbillstate"
        >
		{this.state.statedata.map(states => (
            <option  
              value={states.value}
            >
              {states.display}
            </option  >
          ))}
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		  </li>
	<li>	
	<p className="popformtext"> Zip Code </p>
	<p className="popforminputs"><TextField name="vbillpin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.vbillpin}
			 inputProps={{tabIndex: "12",maxLength:15}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		  <div className="clear"></div>
</li>
	</ul></div>		
	<div className="otherdetailsright">
	<ul>
		  	<li>
	<p className="popformtext"> </p><p className="popforminputs">
<FormControlLabel
  label="1099 Vendor"
  control={
    <Checkbox
      checked={this.state.isvendors}
      onChange={this.handlevendors}
      inputProps={{ 'aria-label': 'controlled' }}
    />
  }
/>
      </p> <div className="clear"></div>
	</li>
<li>	
	<p className="popformtext"> Vendor Tax ID</p>
	<p className="popforminputs"><TextField name="taxcode" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    disabled={this.state.creditlimitdisable}
	    placeholder="e.g.123-45-678 or 12-345678 "
	   value={this.state.taxcode}
		 inputProps={{tabIndex: "12"}}	 
			  ref={this.usernameInput}
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>
	<li>
		 <p className="popformtext"> Account Default <span className="validation">*</span></p>
		  <p><FormControl  className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.ledgerlabel, value: this.state.vledger}}
          onChange={this.myChangeHandler}
          id="vledger"
		  className="txtbox"
		   value={this.state.vledger} 
		  name="vledger"
		inputProps={{tabIndex: "13"}}
        >
		{this.state.ledgerdata.map(vledger => (
            <option  
              value={vledger.value}
            >
              {vledger.display}
            </option  >
          ))}
        </Select></FormControl>
		<div className="clear"></div>
		</p>	
		  </li>
<li>
		 <p className="popformtext"> Tax Rate <span className="validation">*</span></p>
		  <p ><FormControl  className="popforminputs">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.taxlabel, value: this.state.vtax}}
          onChange={this.myChangeHandler}
          id="vtax"
		   value={this.state.vtax} 
		  name="vtax"
		  className="txtbox"
		inputProps={{tabIndex: "14"}}
        >
		{this.state.taxdata.map(vtax => (
            <option  
              value={vtax.value}
            >
              {vtax.display}
            </option  >
          ))}
        </Select></FormControl>
		</p>
		  <div className="clear"></div>
		  </li>
		  </ul>	
			</div>	
	  <div className="clear"></div>
</div>	
		 )}		 
 {this.state.tab==="1" && (
 <div className="Accountform">
    <div className="addresleft">
<ul>
 <h2>Payment Terms</h2>
	<li>	
	<p className="popformtext"> <FormControlLabel
        label="Set Credit Limits($)"
        control={ <Checkbox  checked={this.state.iscreditlimit}  onChange={this.handlecreditlimitChange}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
	<p className="popforminputs"><TextField name="ve_creditlimit" 
	   onChange={this.myChangeHandler}  
	   fullWidth
	 disabled={this.state.creditlimitdisable}
			  value={this.state.ve_creditlimit}
			  inputProps={{tabIndex: "15"}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		  <div className="clear"></div>
</li>	
	<li>	
	<p className="popformcheckbx"><FormControlLabel
        label="Set Credit Terms"
        control={ <Checkbox  checked={this.state.iscreditterms}  onChange={this.handlecreditterms}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p><p className="popformcheckbxinput"></p>
		  <div className="clear"></div>
</li>
 {this.state.iscreditterms===true && (<React.Fragment>
<li>
<p className="popformcheckbx">
 <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue=""
        name="radio-buttons-group"
		  value={this.state.credittermstype}
    onChange={this.handleradiocredit}
      >
        <FormControlLabel value="1" control={<Radio />} label="days after invoice date" />
        <FormControlLabel value="2" control={<Radio />} label="End of next month (Net monthly)" />
        <FormControlLabel value="3" control={<Radio />} label="Immediately" />
      </RadioGroup>
    </FormControl>
</p><p className="popformcheckbxinput">
	 {this.state.credittermstype==="1" && (<React.Fragment>
	<TextField name="ve_creditnoofdays" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    value={this.state.ve_creditnoofdays}
	  inputProps={{tabIndex: "16"}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
                         />
	</React.Fragment> )}				 
	</p>	  <div className="clear"></div>
</li>
	</React.Fragment>)}				  
</ul></div>
	<div className="otherdetailsright">
		  <h2>Bank Details</h2>
		  <ul>
		<li>
	<p className="popformtext">Account Name</p>
	<p className="popforminputs"><TextField name="ve_bankaccountname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ve_bankaccountname}
			 inputProps={{tabIndex: "18",maxLength:150}} 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>		
	<li>
	<p className="popformtext"> ABA/Routing<br/> Number</p>
	<p className="popforminputs"><TextField name="ve_bankroutingno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ve_bankroutingno}
			 inputProps={{tabIndex: "19",maxLength:15}}  
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>		
	<li>
	<p className="popformtext">Account Number</p>
	<p className="popforminputs"><TextField name="ve_bankaccountno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ve_bankaccountno}
		 inputProps={{tabIndex: "20",maxLength:50}} 	 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>
		   <div className="clear"></div>
</li>
</ul></div>	<div className="clear"></div>
</div>	
 )}
 {this.state.tab==="2" && (
<div className="Accountform">
 <p>Notes</p>
<p><TextField name="ve_notes" 
	   onChange={this.myChangeHandler} 
	 fullWidth
	      multiline
          rows={4}
	   value={this.state.ve_notes}
		inputProps={{tabIndex: "21"}}	 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
		  /></p>	
 </div>	
 )}
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickvendorclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlevendorclose}>
    {this.state.submitbtn}
</Button>
    </div>        
<div className="clear"></div>
 </div>     
	</div>	
</DialogContent>
    </Dialog>
</React.Fragment>
) }
}